type AppRuntimeConfig = {
  googleClientId?: string;
  allowedDomain?: string;
};

declare global {
  interface Window {
    __APP_CONFIG__?: AppRuntimeConfig;
  }
}

const runtimeConfig = window.__APP_CONFIG__ ?? {};

export const appAuthConfig = {
  googleClientId: runtimeConfig.googleClientId ?? '',
  allowedDomain: runtimeConfig.allowedDomain ?? 'masterteam.sa'
} as const;
